import {$http} from '@/utils/https'
import {
    SET_LATEST_PRODUCTS,
    SET_HOME_CONTENT,
    SET_CONTACTS_CONTENT,
    SET_MENU_CONTENT,
    SET_ABOUT_CONTENT,
    SET_NEWS,
    SET_CURRENT_NEWS,
    MENU_LOADING,
    CONTACTS_LOADING,
    HOME_CONTENT_LOADING,
    LATEST_PRODUCTS_LOADING,
    ARTICLES_LOADING,
    ABOUT_LOADING, SET_SORT_NEWS,

} from '../mutation-types';
import {
    CONTACTS_CONTENT,
    HOME_CONTENT,
    LATEST_PRODUCTS,
    MENU_CONTENT,
    ABOUT_CONTENT,
    NEWS,
    CURRENT_NEWS, SORT_NEWS
} from '../action-types';


const state = {
    productData: [],
homeContent: { homeMain: { homeMainTitle: '', homeMainText: '', homeMainButtonTitle: '' }, homeSection: { homeSectionImage: '', homeSectionTitle1: '', homeSectionTitle2: '', homeSectionText1: '', homeSectionText2: '' } },
    contactsContent: { phones: [], emails: [], address: '', facebook: '', instagram: '', map_link: '' },
    menuContent: [],
    aboutContent: '',
    news: [],
    currentNews: '',
    menuLoading: false,
    contactsLoading: false,
    homeContentsLoading: false,
    latestProductsLoading: false,
    articlesLoading: false,
    aboutLoading: false,
};

const actions = {
    [CURRENT_NEWS]: async ({commit}, slug) => {
        // commit(CHANGE_LOADING_LIST, true);
        try {

            const response = await $http.get(`v1/articles/${slug}`);

            commit(SET_CURRENT_NEWS, response.data?.data);
        } catch (e) {
            throw e;
        } finally {
            // commit(CHANGE_LOADING_LIST, false);
        }
    },
    [NEWS]: async ({commit},payload) => {
        try {
            const response = await $http.get(`v1/articles?orderBy=${payload.orderBy}`);
            commit(ARTICLES_LOADING, true);
            commit(SET_NEWS, response.data?.data);
        } catch (e) {
            throw e;
            commit(ARTICLES_LOADING, false);
        } finally {

        }
    },
    [ABOUT_CONTENT]: async ({commit}) => {

        try {
            const response = await $http.get(`v1/about`);
            commit(ABOUT_LOADING, true);
            commit(SET_ABOUT_CONTENT, response.data?.data);
        } catch (e) {
            throw e;
            commit(ABOUT_LOADING, false);
        } finally {

        }
    },
    [MENU_CONTENT]: async ({commit}) => {

        try {
            const response = await $http.get(`v1/menu`);
            commit(MENU_LOADING, true);
            commit(SET_MENU_CONTENT, response.data?.data);
        } catch (e) {
            commit(MENU_LOADING, false);
            throw e;
        } finally {

        }
    },
    [CONTACTS_CONTENT]: async ({commit}) => {

        try {
            const response = await $http.get(`v1/contacts`);
            commit(CONTACTS_LOADING, true);
            commit(SET_CONTACTS_CONTENT, response.data?.data);
        } catch (e) {
            commit(CONTACTS_LOADING, false);
            throw e;
        } finally {

        }
    },
    [HOME_CONTENT]: async ({commit}) => {

        try {
            const response = await $http.get(`v1/home`);
            commit(HOME_CONTENT_LOADING, true);
commit(SET_HOME_CONTENT, response.data?.data?.settings || {});
        } catch (e) {
            commit(HOME_CONTENT_LOADING, false);
            throw e;
        } finally {

        }
    },
    [LATEST_PRODUCTS]: async ({commit}) => {

        try {
            const response = await $http.get(`v1/products/popular`);
            commit(LATEST_PRODUCTS_LOADING, true);
            commit(SET_LATEST_PRODUCTS, response.data?.data);
        } catch (e) {
            commit(LATEST_PRODUCTS_LOADING, false);
            throw e;
        } finally {

        }
    },
}

const getters = {
    productData: state => state.productData,
    homeContent: state => state.homeContent,
    contactsContent: state => state.contactsContent,
    menuContent: state => state.menuContent,
    aboutContent: state => state.aboutContent,
    news: state => state.news,
    currentNews: state => state.currentNews,
    menuLoading: state => state.menuLoading,
    contactsLoading: state => state.contactsLoading,
    homeContentsLoading: state => state.homeContentsLoading,
    latestProductsLoading: state => state.latestProductsLoading,
    articlesLoading: state => state.articlesLoading,
    aboutLoading: state => state.aboutLoading,

};

const mutations = {

    [ABOUT_LOADING](state, status) {
        state.aboutLoading = status
    },
    [ARTICLES_LOADING](state, status) {
        state.articlesLoading = status
    },
    [LATEST_PRODUCTS_LOADING](state, status) {
        state.latestProductsLoading = status
    },
    [HOME_CONTENT_LOADING](state, status) {
        state.homeContentsLoading = status
    },
    [CONTACTS_LOADING](state, status) {
        state.contactsLoading = status
    },
    [MENU_LOADING](state, status) {
        state.menuLoading = status
    },
    [SET_CURRENT_NEWS](state, list) {
        state.currentNews = list
    },

    [SET_NEWS](state, list) {
        state.news = list
    },
    [SET_ABOUT_CONTENT](state, list) {
        state.aboutContent = list
    },
    [SET_LATEST_PRODUCTS](state, list) {
        state.productData = list
    },
    [SET_HOME_CONTENT](state, list) {
        state.homeContent = list
    },
    [SET_CONTACTS_CONTENT](state, list) {
        state.contactsContent = list
    },
    [SET_MENU_CONTENT](state, list) {
        state.menuContent = list
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
}
